<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <h5 class="font-medium election-title">📄 Lifting of Pulses, Salt and Oil Under PDS</h5>
                </div>
                <div class="card-body">
                    <form [formGroup]="targetForm" (ngSubmit)="GetPDSStockLifting()">
                        <div class="row align-items-end">

                      <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                  <option value="">--Select--</option>
                  <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                    {{ circle?.sCircleName }}
                  </option>
                </select>
                <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                  class="text-danger small">
                  Circle office is required
                </div>
              </div>
                            <!-- Block Office -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="blockOffice">
                                    <option value="" selected>--Select--</option>
                                    <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                        {{ circle?.sBlockName }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                                    class="text-danger small">
                                    block Office is required
                                </div>
                            </div>

                            <!-- Financial Year -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Financial/Reporting Year <span
                                        class="text-danger">*</span></label>
                                <select class="form-control" formControlName="financialYear">
                                    <option value="">--Select--</option>
                                    <option *ngFor="let years of financialYears" [ngValue]="years">
                                        {{ years?.financialYear }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                                    class="text-danger small">
                                    Financial year is required
                                </div>
                            </div>

                            <!-- Submit -->
                            <div class="col-lg-12 text-end">
                                <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                                    Get Report
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <div class="d-flex align-items-center justify-content-between gap-1">
                        <h5 class="font-medium m-0">📄 Reports</h5>
                        <button type="button" class="btn btn-info btn-sm" data-bs-toggle="modal"
                            data-bs-target="#LiftingPulsesUnderPDSModal" (click)="addData()" *ngIf="showButton && (this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)">Add Data for {{currentMonth?.name}}</button>
                        <!-- Modal -->
                        <div class="modal fade" id="LiftingPulsesUnderPDSModal" data-bs-backdrop="static"
                            data-bs-keyboard="false" tabindex="-1" aria-labelledby="LiftingPulsesUnderPDSModalLabel"
                            aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl ">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h1 class="modal-title fs-5" id="LiftingPulsesUnderPDSModalLabel" >Add PDS Stock
                                            Lifting Details</h1>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close" (click)="closeModel()"></button>
                                    </div>
                                    <div class="modal-body">

                                        <!-- <div class="row">

                                            <div class="col-lg-4 col-md-6 mb-2">
                                                <label class="form-label">Financial/Reporting Year<sup
                                                        class="text-danger">*</sup></label>
                                                <input type="text" class="form-control" value="2025-26" disabled />
                                            </div>

                                            <div class="col-lg-4 col-md-6 mb-2">
                                                <label class="form-label">Block Office<sup
                                                        class="text-danger">*</sup></label>
                                                <input type="text" class="form-control"
                                                    value="Shimla Urban - Block Office" disabled />
                                            </div>

                                            <div class="col-lg-4 col-md-6 mb-2">
                                                <label class="form-label">Data For Month<sup
                                                        class="text-danger">*</sup></label>
                                                <input type="text" class="form-control" value="June, 2025" disabled />
                                            </div>

                                            <div class="col-lg-4 col-md-6 mb-2">
                                                <label class="form-label">Total No. of FPS<sup
                                                        class="text-danger">*</sup></label>
                                                <input type="text" class="form-control" />
                                            </div>

                                            <div class="col-lg-4 col-md-6 mb-2">
                                                <label class="form-label">No. of FPS who did not lift the stock<sup
                                                        class="text-danger">*</sup></label>
                                                <input type="text" class="form-control" />
                                            </div>

                                            <div class="col-lg-12">
                                                <label class="form-label">Item wise Allotment and Lifting Details<sup
                                                        class="text-danger">*</sup></label>

                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-hover">
                                                        <thead>

                                                            <tr>
                                                                <th>#</th>
                                                                <th>Item Name</th>
                                                                <th>Allotment for September, 2025 (in Qtl./Ltrs.)</th>
                                                                <th>Lifted during September, 2025 (in Qtl./Ltrs.)</th>
                                                            </tr>

                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>1</td>
                                                                <td>Pulses</td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="Allotment of Pulses" />
                                                                        <span class="input-group-text">Qtls.</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="Allotment of Pulses" />
                                                                        <span class="input-group-text">Qtls.</span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>2</td>
                                                                <td>Salt</td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="Allotment of Salt" />
                                                                        <span class="input-group-text">Qtls.</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="Lifting of Salt" />
                                                                        <span class="input-group-text">Qtls.</span>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td>3</td>
                                                                <td>Oil (Refined & Mustard)</td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="Allotment of Oil" />
                                                                        <span class="input-group-text">Ltrs.</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="Lifting of Oil " />
                                                                        <span class="input-group-text">Ltrs.</span>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                        </tbody>


                                                    </table>
                                                </div>

                                            </div>

                                            <div class="col-lg-4 mb-2">
                                                <label class="form-label">Percentage of Lifting the Stock<sup
                                                        class="text-danger">*</sup></label>
                                                <div class="input-group">
                                                    <input type="text" class="form-control" disabled />
                                                    <span class="input-group-text">%</span>
                                                </div>
                                            </div>

                                            <div class="col-lg-8">
                                                <label class="form-label">Reason for not lifting the stock</label>
                                                <textarea class="form-control" rows="3"
                                                    placeholder="Please write your valid Reasons"></textarea>
                                            </div>


                                        </div> -->

                                        <form [formGroup]="stockLiftingForm">
  <div class="row">
  <!-- Financial Year -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">Financial/Reporting Year <span
                                                            class="text-danger">*</span></label>
                                                    <select class="form-control" formControlName="financialYear">
                                                        <option value="">--Select--</option>
                                                        <option *ngFor="let years of financialYears" [ngValue]="years">
                                                            {{ years?.financialYear }}
                                                        </option>
                                                    </select>
                                                    <div *ngIf="stockLiftingForm.get('financialYear')?.touched && stockLiftingForm.get('financialYear')?.invalid"
                                                        class="text-danger small">
                                                        Financial year is required
                                                    </div>
                                                </div>


                                                <!-- Block Office -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">Block Office <span
                                                            class="text-danger">*</span></label>
                                                    <select class="form-control" formControlName="blockOffice">
                                                        <option value="" selected>--Select--</option>
                                                        <option *ngFor="let circle of blockList"
                                                            [value]="circle?.iBlockId">
                                                            {{ circle?.sBlockName }}
                                                        </option>
                                                    </select>
                                                    <div *ngIf="stockLiftingForm.get('blockOffice')?.touched && stockLiftingForm.get('blockOffice')?.invalid"
                                                        class="text-danger small">
                                                        block Office is required
                                                    </div>
                                                </div>


                                                <!-- During Month -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">During Month <span
                                                            class="text-danger">*</span></label>
                                                    <!-- <input class="form-control" type="month" formControlName="duringMonth" placeholder="e.g., May 2025" /> -->
                                                    <select class="form-control" formControlName="dataMonth">
                                                        <option value="" selected>--Select Month--</option>
                                                        <option *ngFor="let month of months" [value]="month?.iMonthId">
                                                            {{ month?.sMonthName }}
                                                        </option>
                                                    </select>

                                                    <div class="text-danger small" style="min-height: 1.25rem;">
                                                        <span
                                                            *ngIf="stockLiftingForm.get('dataMonth')?.touched && stockLiftingForm.get('dataMonth')?.invalid">
                                                            This field is required
                                                        </span>
                                                    </div>
                                                </div>

    <!-- Total FPS -->
    <div class="col-lg-6 col-md-6 mb-2">
      <label class="form-label">Total No. of FPS<sup class="text-danger">*</sup></label>
      <input type="text" class="form-control" formControlName="totalFPS" placeholder="Enter the value" (input)="allowOnlyInteger($event, 5)" />
      <div *ngIf="stockLiftingForm.get('totalFPS')?.touched && stockLiftingForm.get('totalFPS')?.invalid" class="text-danger small">
        Total FPS is required and must be a number.
      </div>
        <div class="text-danger small"
       *ngIf="stockLiftingForm.get('fpsNotLifted')?.value?.toString()?.length > 10">
    Maximum 5 digits allowed
  </div>
    </div>

    <!-- FPS Not Lifted -->
    <div class="col-lg- col-md-6 mb-2">
      <label class="form-label">No. of FPS who did not lift the stock<sup class="text-danger">*</sup></label>
      <input type="text" class="form-control" formControlName="fpsNotLifted" placeholder="Enter the value" (input)="allowOnlyInteger($event, 5)" />
      <div *ngIf="stockLiftingForm.get('fpsNotLifted')?.touched && stockLiftingForm.get('fpsNotLifted')?.invalid" class="text-danger small">
        This field is required and must be a number.
      </div>
        <div class="text-danger small"
       *ngIf="stockLiftingForm.get('fpsNotLifted')?.value?.toString()?.length > 10">
    Maximum 5 digits allowed
  </div>
    </div>

    <!-- Item Table -->
    <div class="col-lg-12">
      <label class="form-label">Item wise Allotment and Lifting Details<sup class="text-danger">*</sup></label>

      <div class="table-responsive" formArrayName="items">
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
               <th>S.No.</th>
              <th>Item Name</th>
              <th>Allotment for September, 2025 (in Qtl./Ltrs.)</th>
              <th>Lifted during September, 2025 (in Qtl./Ltrs.)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items['controls']; let i = index" [formGroupName]="i">
              <td>{{ i + 1 }}</td>
              <td>{{ item.value.itemName }}</td>

              <!-- Allotment -->
              <td>
                <div class="input-group">
                  <input type="text" class="form-control" formControlName="allotment" [placeholder]="'Allotment of ' + item.value.itemName" />
                  <span class="input-group-text">{{ item.value.unit }}</span>
                </div>
                <div *ngIf="item.get('allotment')?.touched && item.get('allotment')?.invalid" class="text-danger small">
                  Required & must be a valid number.
                </div>
              </td>

              <!-- Lifted -->
              <td>
                <div class="input-group">
                  <input type="text" class="form-control" formControlName="lifted" [placeholder]="'Lifting of ' + item.value.itemName" />
                  <span class="input-group-text">{{ item.value.unit }}</span>
                </div>
                <div *ngIf="item.get('lifted')?.touched && item.get('lifted')?.invalid" class="text-danger small">
                  Required & must be a valid number.
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Lifting % -->
    <div class="col-lg-4 mb-2">
      <label class="form-label">Percentage of Lifting the Stock<sup class="text-danger">*</sup></label>
      <div class="input-group">
        <input type="text" class="form-control" formControlName="liftingPercentage"  />
        <span class="input-group-text">%</span>
      </div>
    </div>

    <!-- Reason -->
    <div class="col-lg-8">
      <label class="form-label">Reason for not lifting the stock</label>
      <textarea class="form-control" formControlName="reason" rows="3" placeholder="Please write your valid Reasons"></textarea>
    </div>
  </div>
</form>

                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal" (click)="closeModel()">Close</button>
                                        <button type="button" class="btn btn-primary" (click)="onSubmit()">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">

<table class="table table-bordered table-hover">
  <thead>
    <tr>
      <th rowspan="2" style="text-align: center; width: 3%">S.No.</th>
      <th rowspan="2">Month</th>
      <th rowspan="2" class="text-right">Total No. of FPS</th>
      <th rowspan="2" class="text-right">No. of FPS who did not Lift the Stock</th>
      <th style="width:20%" class="text-center" colspan="3">Allotment <br>(in Qtls./Ltrs.)</th>
      <th style="width:20%" class="text-center" colspan="3">Lifting <br>(in Qtls./Ltrs.)</th>
      <th rowspan="2" class="text-right">Percentage of Lifting the Stock</th>
      <th rowspan="2">Reason for not Lifting the Stock</th>
      <th rowspan="2" class="text-center" style="width: 3%">Action</th>
    </tr>
    <tr>
      <th class="text-right">Pulses</th>
      <th class="text-right">Salt</th>
      <th class="text-right">Oil</th>
      <th class="text-right">Pulses</th>
      <th class="text-right">Salt</th>
      <th class="text-right">Oil</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of stockLiftingList; let i = index">
      <td class="text-center">{{ i + 1 }}</td>
      <td class="no-wrap">{{ getMonthName(item.dataMonth) }}, {{ item.financialYear?.split('-')[0] }}</td>
      <td class="text-right">{{ item.totalFPS }}</td>
      <td class="text-right">{{ item.noOfFPSWhoDidNotLift }}</td>
      <td class="text-right">{{ item.allotmentPulses | number:'1.2-2' }}</td>
      <td class="text-right">{{ item.allotmentSalt | number:'1.2-2' }}</td>
      <td class="text-right">{{ item.allotmentOil | number:'1.2-2' }}</td>
      <td class="text-right">{{ item.liftingPulses | number:'1.2-2' }}</td>
      <td class="text-right">{{ item.liftingSalt | number:'1.2-2' }}</td>
      <td class="text-right">{{ item.liftingOil | number:'1.2-2' }}</td>
      <td class="text-right">{{ item.percentageOfLifting | number:'1.2-2' }}%</td>
      <td class="font-size-12">{{ item.reasonForNotLifting }}</td>
      <td class="text-center no-wrap">
       <ng-container *ngIf="!item.isVerified && ( this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13 ); else verifiedBlock">
         <button type="button" class="btn btn-primary btn-sm" title="Click to Edit"
               (click)="editRow(item)">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button type="button" class="btn btn-success btn-sm" title="Click to Verify" *ngIf="this.UserDetails?.roleId ==13"
               data-bs-toggle="modal" data-bs-target="#verifyConfirmModal" (click)="setDeleteIndex(item?.id)">
              <i class="bi bi-clipboard2-check"></i>
            </button>
            <button type="button" class="btn btn-danger btn-sm" title="Click to Delete"
              data-bs-toggle="modal" data-bs-target="#deleteConfirmModal"
                                                (click)="setDeleteIndex(item?.id)" >
              <i class="bi bi-trash3"></i>
            </button>
          
        </ng-container>
        <ng-template #verifiedBlock>
          <button type="button" class="btn btn-primary btn-sm" title="Verified">
            <i class="bi bi-lock"></i>
          </button>
        </ng-template>
      </td>
    </tr>
  </tbody>
</table>

  <!-- Delete Confirmation Modal -->
                        <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                            aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to delete ?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal" (click)="cancelDelete()">Cancel</button>
                                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="DeletePDSStockLifting(deleteIndex)">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- verify Confirmation Modal -->
                        <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                            aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to Verify?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal" (click)="this.deleteIndex = 0;">Cancel</button>
                                        <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="verifyPDSStockLifting(deleteIndex)">Verify</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <table class="table table-bordered table-hover">
                            <thead>

                                <tr>
                                    <th rowspan="2" style="text-align: center; width: 3%">#</th>
                                    <th rowspan="2">Month</th>
                                    <th rowspan="2" class="text-right">Total No. of FPS</th>
                                    <th rowspan="2" class="text-right">No. of FPS who did not Lift the Stock</th>
                                    <th style="width:20%" class="text-center" colspan="3">Allotment <br>(in Qtls./Ltrs.)
                                    </th>
                                    <th style="width:20%" class="text-center" colspan="3">Lifting <br>(in Qtls./Ltrs.)
                                    </th>
                                    <th rowspan="2" class="text-right">Percentage of Lifting the Stock</th>
                                    <th rowspan="2">Reason for not Lifting the Stock</th>
                                    <th rowspan="2" class="text-center" style="width: 3%">Action</th>
                                </tr>
                                <tr>
                                    <th class="text-right">Pulses</th>
                                    <th class="text-right">salt</th>
                                    <th class="text-right">Oil</th>
                                    <th class="text-right">Pulses</th>
                                    <th class="text-right">salt</th>
                                    <th class="text-right">Oil</th>
                                </tr>

                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-center">1.</td>
                                    <td class="no-wrap">April, 2025</td>
                                    <td class="text-right">38</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">850.00</td>
                                    <td class="text-right">380.00</td>
                                    <td class="text-right">11000.00</td>
                                    <td class="text-right">850.00</td>
                                    <td class="text-right">380.00</td>
                                    <td class="text-right">11000.00</td>
                                    <td class="text-right">100.00%</td>
                                    <td class="font-size-12"></td>
                                    <td class="text-center no-wrap">
                                        <button type="button" class="btn btn-primary btn-sm"
                                            title="Verified on 05/02/2025 04:25:00 PM"><i
                                                class="bi bi-lock"></i></button>
                                    </td>
                                </tr>



                            </tbody>
                        </table> -->

                    </div>
                </div>
            </div>
        </div>


    </div>
</div>